import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class TemplatesRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/templates(/)")
    route () {
        System.import("./index").then(View => {
            const view = new View.default();

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default TemplatesRoute;



// WEBPACK FOOTER //
// ./public/domain/views/templates/templates.route.js